import ToolStylus from './ToolStylus';
import Shortcut from '../utils/Shortcut';

class ToolStylusPen extends ToolStylus {
  static toolName = 'Pen';
  static shortcut = new Shortcut('P');

  static action({ controller }) {
    controller.actionSetStylus(controller.currentPenStylus);
  }
}

export default ToolStylusPen;
